import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./motion";
import { STEPS } from "../lib/site";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section className="relative bg-ink py-28 text-white md:py-40" data-testid="process-section">
      <div className="grain" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-[1400px] gap-16 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal><Eyebrow dark>How it works</Eyebrow></Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-display text-4xl font-semibold leading-[1] tracking-tight md:text-6xl">
                A proposal, <span className="font-serif font-normal italic text-glint">not</span> a price tag.
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-slate-300 md:text-lg">
                Commercial spaces are never identical, so we don't auto-price recurring contracts. Every engagement follows the same four steps — and nothing is booked until you approve it.
              </p>
            </Reveal>
          </div>
        </div>
        <ol ref={ref} className="relative lg:col-span-7">
          <div className="absolute bottom-0 left-[19px] top-0 w-px bg-white/10" aria-hidden="true" />
          <motion.div style={{ scaleY }} className="absolute bottom-0 left-[19px] top-0 w-px origin-top bg-glint" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal as="li" key={s.t} className="relative pb-14 pl-16 last:pb-0" delay={0.04 * i}>
              <span className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-ink font-mono text-xs text-glint" data-testid={`process-step-${i + 1}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display text-2xl font-medium md:text-3xl">{s.t}</h3>
              <p className="mt-3 max-w-lg text-base leading-relaxed text-slate-300">{s.d}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
